/*
 * Product · Benefits tabs (sections/pdp-benefits.liquid).
 * Click or arrow keys switch panels (automatic activation, like Replo's Radix
 * tabs). Panel images are lazy, so once the section nears the viewport the
 * hidden panels' images are switched to eager to avoid a blank flash on switch.
 */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.pdpBenefitsInit) return;
    root.pdpBenefitsInit = true;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-benefits-tab]'));
    if (!tabs.length) return;

    var panels = tabs.map(function (tab) {
      return document.getElementById(tab.getAttribute('aria-controls'));
    });

    function select(index, focus) {
      if (index < 0 || index >= tabs.length) return;
      tabs.forEach(function (tab, i) {
        var active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (panels[i]) panels[i].hidden = !active;
      });
      if (focus) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        select(i, false);
      });

      tab.addEventListener('keydown', function (event) {
        var next = null;
        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            next = (i + 1) % tabs.length;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            next = (i - 1 + tabs.length) % tabs.length;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = tabs.length - 1;
            break;
        }
        if (next === null) return;
        event.preventDefault();
        select(next, true);
      });
    });

    root.pdpBenefitsSelect = function (panel) {
      var index = panels.indexOf(panel);
      if (index !== -1) select(index, false);
    };

    function preload() {
      root.querySelectorAll('.pdp-benefits__panel img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) {
            preload();
            io.disconnect();
          }
        },
        { rootMargin: '600px 0px' }
      );
      io.observe(root);
    } else {
      preload();
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-pdp-benefits]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var panel = event.target.closest && event.target.closest('[data-pdp-benefits-panel]');
    if (!panel) return;
    var root = panel.closest('[data-pdp-benefits]');
    if (!root) return;
    init(root);
    if (root.pdpBenefitsSelect) root.pdpBenefitsSelect(panel);
  });
})();
